"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FrameworkLinkModel = /** @class */ (function () {
    function FrameworkLinkModel(rFItemId, rFLevel, iFItemId, iFSystemName) {
        if (iFItemId === void 0) { iFItemId = null; }
        if (iFSystemName === void 0) { iFSystemName = null; }
        this.rFItemId = rFItemId;
        this.rFLevel = rFLevel;
        this.iFItemId = iFItemId;
        this.iFSystemName = iFSystemName;
    }
    FrameworkLinkModel.prototype.getParams = function () {
        return {
            rFItemId: this.rFItemId,
            rFLevel: this.rFLevel,
            iFItemId: this.iFItemId || null,
            iFSystemName: this.iFSystemName || null
        };
    };
    FrameworkLinkModel.prototype.getQuery = function (languageId) {
        var paramsObj = this.getParams();
        var query = [];
        for (var key in paramsObj) {
            if (paramsObj.hasOwnProperty(key) && paramsObj[key]) {
                query.push(key + '=' + paramsObj[key]);
            }
        }
        query.push('languageId=' + languageId);
        return query.join('&');
    };
    return FrameworkLinkModel;
}());
exports.FrameworkLinkModel = FrameworkLinkModel;
//# sourceMappingURL=framework-link.model.js.map